import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/",
    component: () => import("../layout"),
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/home"),
        meta: {
          title: "湛江狮子陵园预约"
        }
      },
      {
        path: "/appointment",
        name: "appointment",
        component: () => import("../views/appointment"),
        meta: {
          title: "湛江狮子陵园预约"
        }
      },
      {
        path: "/my",
        name: "my",
        component: () => import("../views/my"),
        meta: {
          title: "我的预约"
        }
      },
      {
        path: "/show",
        name: "show",
        component: () => import("../views/show"),
        meta: {
          title: "预约展示"
        }
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
